import { BaseObject } from '@uniqoders/sdk';
export default class User extends BaseObject {
    get name() {
        return this.attributes.name;
    }
    get surname() {
        return this.attributes.surname;
    }
    get fullName() {
        return this.attributes.full_name;
    }
    get email() {
        return this.attributes.email;
    }
    get emailVerifiedAt() {
        return this.attributes.email_verified_at;
    }
    get pmLastFour() {
        return this.attributes.pm_last_four;
    }
    get pmType() {
        return this.attributes.pm_type;
    }
    get stripeId() {
        return this.attributes.stripe_id;
    }
    get trialEndsAt() {
        return this.attributes.trial_ends_at;
    }
    get twoFactorRecoveryCodes() {
        return this.attributes.two_factor_recovery_codes;
    }
    get twoFactorSecret() {
        return this.attributes.two_factor_secret;
    }
    get hasPassword() {
        return this.attributes.has_password;
    }
}
